import { useParams } from "react-router-dom";
import database from "../data/database.json";
import HeaderLegal from "../layouts/HeaderLegal";
import ContentLegal from "../layouts/ContentLegal";
import { UseScrollToTop } from "../helpers";
import { UseStickyNav } from "../helpers";
import TabLinks from "../components/TabLinks";

const Legal = () => {
  UseScrollToTop();
  UseStickyNav();
  const { id } = useParams();

  const dataLegal = database.legals.find((legal) => legal.id === id);

  return (
    <div className="content-wrapper">
      <TabLinks />
      <HeaderLegal data={dataLegal} />
      <ContentLegal data={dataLegal} />
    </div>
  );
};

export default Legal;
